import type { SurveyResponse } from "@qendo/survey";
import type { Improvement, MoreLessNoChange, MoreOrLess, YesNoNa } from "@qendo/survey/fields";
import Data from "~/util/data";

export class AnnualSurvey2025Data extends Data implements SurveyResponse {
    constructor(
        public new_user: boolean | null = null,
        public postcode: string = "",
        public ethnicity: string = "",
        public languages: string = "",
        public unplanned_visits: boolean | null = null,
        public visiting_gp: MoreOrLess | null = null,
        public employment_tools: YesNoNa | null = null,
        public movement: MoreLessNoChange | null = null,
        public eating_habits: Improvement | null = null,
        public mental_health: Improvement | null = null,
        public daily_activities: Improvement | null = null,
    ) {
        super();
    }

    public valid(): boolean {
        return this.filled();
    }
}
